<template>
  <div class="container ">
    <div class="tariff__desktop mb--10">
      <div class="tariff--wrap">
        <h3 class="tariff--bordered">Тарифы</h3>
        <div v-for="(tariff, idx) in tariffs" :key="idx">
          <div class="tariff__header tariff--bordered">
            <div class="tariff__bangs" :style="{background: tariff.color}">
              <span class="tariff--uppercase">{{tariff.label.text}}</span>
              <span v-if="tariff.label.sub" class="tariff--normal">{{tariff.label.sub}}</span>
            </div>
            <h5 :style="{color: tariff.color}">{{tariff.price}}</h5>
            <BaseButton
                :colorCustom="tariff.color"
                buttonStyle="tariff__button"
                @click="openRequestModal"
            >Подключить</BaseButton
            >
          </div>
        </div>
      </div>
      <div
          class="tariff--wrap"
          v-for="(label, idy) in labels"
          :key="idy"
      >
        <h4 class="tariff__label tariff--bordered text--dark-black">{{label}}</h4>
        <div v-for="(tariff, idz) in tariffs" :key="idz">
          <div class="tariff__cell tariff--bordered">
            <img
                v-if="tariff.services.find(service => service === label)"
                src="../../assets/icons/selected.svg"
                alt="selected"
            >
            <span v-else>-</span>
          </div>
        </div>
      </div>
    </div>
    <div class="tariff__mobile mb--3">
      <h3 class="mb--5">Тарифы</h3>
      <div
          v-for="(tariff, idx) of tariffs"
          :key="idx"
          class="tariff__card"
      >
        <div class="tariff__bangs" :style="{background: tariff.color}">
          <span class="tariff--uppercase">{{tariff.label.text}}</span>
          <span v-if="tariff.label.sub" class="tariff--normal">{{tariff.label.sub}}</span>
        </div>
        <div class="tariff__body mb--5">
          <div
              v-for="(service, idy) of tariff.services"
              :key="idy"
              class="tariff__service text--dark-black"
          >
            <img src="../../assets/icons/selected.svg" alt="selected">
            <span>{{service}}</span>
          </div>
        </div>
        <h3 class="mb--3" :style="{color: tariff.color}">{{tariff.price}}</h3>
        <BaseButton
            :colorCustom="tariff.color"
            size="normal"
            @click="openRequestModal"
        >Подключить</BaseButton
        >
      </div>
    </div>
    <p class="tariff__tip text--dark mb--5">
      Указана стоимость без НДС.
    </p>
    <div class="mb--5">
      <p class="paragraph text--dark" v-for="(info, idx) in infos" :key="idx">
        {{ info }}
      </p>
    </div>
    <RequestReportForm :request-type="4">
      <p class="paragraph mb--2">
        Заполните форму ниже, чтобы приобрести данный пакет тарифа
      </p>
    </RequestReportForm>
  </div>
</template>

<script>
import RequestReportForm from "@/views/visual-analytics/components/RequestReportForm.vue";
import BaseButton from "../../components/base/BaseButton";

export default {
  components: {
    BaseButton,
    RequestReportForm,
  },
  data() {
    return {
      tariffs: [
        {
          label: {
            text: "FCB VA FREE",
            sub: "",
          },
          price: "Бесплатно",
          services: ["Дайджесты", "Отчетность (НБРК / Статистика)", "Demo Отчеты"],
          color: "#46ADF4"
        },
        {
          label: {
            text: "FCB VA STANDART",
            sub: "(Retail)",
          },
          price: "350 000 ₸/мес",
          services: ["Дайджесты", "Отчетность (НБРК / Статистика)", "Отчеты Банк / Рынок Retail"],
          color: "#00557C"
        },
        {
          label: {
            text: "FCB VA STANDART",
            sub: "(Business)",
          },
          price: "350 000 ₸/мес",
          services: ["Дайджесты", "Отчетность (НБРК / Статистика)", "Отчеты Банк / Рынок Business"],
          color: "#00557C"
        },
        {
          label: {
            text: "FCB VA premium",
            sub: "",
          },
          price: "600 000 ₸/мес",
          services: ["Дайджесты", "Отчетность (НБРК / Статистика)", "Отчеты Банк / Рынок Retail", "Отчеты Банк / Рынок Business"],
          color: "#263238"
        },
        {
          label: {
            text: "FCB VA MARKET",
            sub: "",
          },
          price: "750 000 ₸/мес",
          services: ["Дайджесты", "Отчетность (НБРК / Статистика)", "Отчеты Рынок Retail", "Отчеты Рынок Business"],
          color: "#0082BE"
        }
      ],
      labels: [
        "Дайджесты",
        "Отчетность (НБРК / Статистика)",
        "Demo Отчеты",
        "Отчеты Рынок Retail",
        "Отчеты Рынок Business",
        "Отчеты Банк / Рынок Retail",
        "Отчеты Банк / Рынок Business",
      ],
      infos: [
        "1. Подписка на пакеты возможна минимум на 6 месяцев ",
        "2. Подключить дополнительные модули отчетов можно в любой период с дополнительной оплатой ",
        "3. Подписка на дополнительные модули не может быть менее чем на 6 месяцев",
        "4. Каждый дополнительный модуль тарифицируется отдельно ",
      ],
    };
  },
  methods: {
    openRequestModal() {
      this.$modal.show("requestReportForm");
    },
  },
};
</script>

<style lang="scss" scoped>
h3 {
  font-weight: 700;
  font-size: 25px;
}
h5 {
  font-weight: 700;
  font-size: 18px;
}
.tariff {
  &__desktop {

    @media (max-width: 1000px) {
      display: none;
    }
  }
  &__mobile {
    display: none;

    @media (max-width: 1000px) {
      display: block;
    }
  }
  &__card {
    background: #FFFFFF;
    box-shadow: 4px 4px 20px rgba(120, 156, 172, 0.4);
    border-radius: 16px;
    padding: 72px 13px 33px 13px;
    position: relative;

    &:not(:last-child) {
      margin-bottom: 40px;
    }
  }
  &__body {
    display: flex;
    flex-direction: column;
    gap: 1.25rem;
  }
  &__service {
    display: flex;
    align-items: center;
    gap: 0.625rem;
    font-weight: 500;
    font-size: 14px;
  }
  &--wrap {
    display: grid;
    grid-template-columns: 270px repeat(5, minmax(0, 1fr));

    & > h3 {
      display: flex;
      align-items: center;
      padding: 10px;
    }
  }
  &__header {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 65px 0 13px;
    position: relative;

    & > h5 {
      margin-bottom: 25px;
    }
  }
  &--uppercase {
    text-transform: uppercase;
  }
  &--normal {
    font-weight: 400;
  }
  &--bordered {
    border-bottom: 1px solid #CCE9FF;
    border-right: 1px solid #CCE9FF;
  }
  &__bangs {
    position: absolute;
    top: 0;
    left: 50%;
    transform: translateX(-50%);
    height: 40px;
    width: 85%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-weight: 700;
    font-size: 12px;
    color: #ffffff;
    letter-spacing: -0.02em;
    border-radius: 0px 0px 16px 16px;
  }
  &__label,
  &__cell {
    font-weight: 500;
    font-size: 14px;
    padding: 10px;
    height: 45px;
    display: flex;
    align-items: center;
  }
  &__label {
    white-space: nowrap;
  }
  &__cell {
    justify-content: center;
  }
  &__tip {
    text-align: right;
    @media (max-width: 1000px) {
      text-align: left;
    }
  }
}
::v-deep {
  .tariff__button {
    font-size: 12px;
    padding: 4px 24px;
    height: 35px;
  }
}
</style>
